import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack, IoShieldCheckmark, IoVideocam, IoPeople, IoMap } from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import './SeguridadScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

function SeguridadScreen() {
    const navigate = useNavigate();
    const { userData, currentUser } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!currentUser) return;

        const q = query(
            collection(db, "chats"),
            where("participants", "array-contains", currentUser.uid)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            let total = 0;
            snapshot.docs.forEach(doc => {
                total += doc.data()[`unread_${currentUser.uid}`] || 0;
            });
            setUnreadCount(total);
        });
        return () => unsubscribe();
    }, [currentUser]);

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/seguridad" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="muro-header-stitch">
                        <div className="muro-hero-card">
                            <div className="muro-hero-content">
                                <h1>Seguridad</h1>
                                <p>Control y vigilancia</p>
                            </div>
                            <IoShieldCheckmark className="muro-hero-icon-decor" />
                        </div>
                    </div>

                    <div className="seguridad-container">

                        <div className="seguridad-grid">
                            {/* Module: Centinela (Cameras) */}
                            <div className="seguridad-module-card" onClick={() => navigate('/seguridad/centinela')}>
                                <div className="module-icon-box centinela">
                                    <IoVideocam />
                                </div>
                                <div className="module-info">
                                    <h3>Centinela</h3>
                                    <p>Cámaras de seguridad en vivo</p>
                                </div>
                            </div>

                            {/* Role-Based Module */}
                            {userData?.rol === 'vigilante' ? (
                                <>
                                    <div className="seguridad-module-card" onClick={() => navigate('/seguridad/residentes')}>
                                        <div className="module-icon-box vigilantes" style={{ position: 'relative' }}>
                                            <IoPeople />
                                            {unreadCount > 0 && (
                                                <div className="notification-badge-module">
                                                    {unreadCount}
                                                </div>
                                            )}
                                        </div>
                                        <div className="module-info">
                                            <h3>Residentes</h3>
                                            <p>Buscar y contactar</p>
                                        </div>
                                    </div>
                                    <div className="seguridad-module-card" onClick={() => navigate('/seguridad/rondines')}>
                                        <div className="module-icon-box rondines" style={{ backgroundColor: '#4CAF50', color: 'white' }}>
                                            <IoMap />
                                        </div>
                                        <div className="module-info">
                                            <h3>Rondines</h3>
                                            <p>Iniciar recorrido</p>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="seguridad-module-card" onClick={() => navigate('/seguridad/vigilantes')}>
                                        <div className="module-icon-box vigilantes" style={{ position: 'relative' }}>
                                            <IoPeople />
                                            {unreadCount > 0 && (
                                                <div className="notification-badge-module">
                                                    {unreadCount}
                                                </div>
                                            )}
                                        </div>
                                        <div className="module-info">
                                            <h3>Comunicaciones</h3>
                                            <p>Chat y control de rondines de vigilancia</p>
                                        </div>
                                    </div>
                                    {['admin', 'comite', 'masteruser', 'superuser'].includes(userData?.rol) && (
                                        <div className="seguridad-module-card" onClick={() => navigate('/seguridad/historial-rondines')}>
                                            <div className="module-icon-box rondines" style={{ backgroundColor: '#4338ca', color: 'white' }}>
                                                <IoMap />
                                            </div>
                                            <div className="module-info">
                                                <h3>Historial de Rondines</h3>
                                                <p>Ver rutas patrulladas</p>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
                <KondoBottomNav activeRoute="/seguridad" />
            </main>
        </div>
    );
}

export default SeguridadScreen;
